<template>
  <div class="">
    <el-row :gutter="20">
      <el-col :span="6">
        <div>
          <el-input v-model="key" placeholder="请输入关键字或词" class="input-with-select" size="small"
                    suffix-icon="el-icon-search" />
        </div>
      </el-col>
      <el-col :span="18" class="btn">
        <div>
          <el-button
            v-if="proStatus!=='项目已锁定'"
            v-permission="['访视管理新增访视']"
            type="primary"
            icon="el-icon-edit-outline"
            size="small"
            @click="addVisitShow"
          >新增访视
          </el-button>
        </div>
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        ref="filterTable"
        v-loading="loading"
        stripe
        size="mini"
        :data="visitData"
        style="width: 100%"
        border
        :cell-style="cellStyle"
        :header-cell-style="tableHeaderColor"
        @filter-change="filterChange"
      >
        <el-table-column
          prop="code"
          label="访视编号"
          width="200"
        />
        <el-table-column
          prop="name"
          label="访视名称"
          width="160"
        >
          <template slot-scope="scope">
            <div style="font-size: 12px;">{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="stage"
          label="访视阶段"
          width="160"
          column-key="stage"
          :filters="stageList"
          filter-placement="bottom-end"
        />
        <el-table-column
          prop="desc"
          label="访视描述"
        />
        <el-table-column
          prop="time_window"
          label="访视窗口期"
          width="160"
        />
        <el-table-column
          fixed="right"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <el-link
              v-permission="['访视管理编辑访视']"
              type="primary"
              :disabled="proStatus==='项目已锁定'"
              :underline="false"
              class="edit"
              @click="showVisit(scope.row)"
            >编辑
            </el-link>
            <el-link
              v-permission="['访视管理删除访视']"
              :disabled="proStatus==='项目已锁定'"
              type="primary"
              :underline="false"
              class="edit"
              style="font-size: 12px;"
              @click="del(scope.row)"
            >删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pages">
      <el-pagination
        samll
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--创建访视-->
    <el-dialog
      :visible.sync="visitDialogVisible"
      :close-on-click-modal="false"
      width="45%"
      center
      @close="cancel"
    >
      <div slot="title" class="title">{{ this.visitId ? '编辑' : '新增' }}访视</div>
      <div class="diaBg">
        <el-row class="row">
          <el-col :span="24" class="info-item">
            <el-row>
              <el-col :span="4">
                <div class="colm-left">访视全称：</div>
              </el-col>
              <el-col :span="20">
                <el-input v-model="name" size="mini"/>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24" class="info-item">
            <el-row>
              <el-col :span="4">
                <div class="colm-left">访视编号：</div>
              </el-col>
              <el-col :span="20">
                <el-input v-model="code" size="mini"/>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24" class="info-item">
            <el-row>
              <el-col :span="4">
                <div class="colm-left">访视时间段:</div>
              </el-col>
              <el-col :span="4">
                <!-- <el-input v-model="time_slot" size="mini" oninput="value=value.replace(/[^\d]/g,'')"/> -->
                <el-input v-model="time_slot" size="mini" type="number"/>
              </el-col>
              <el-col :span="4" style="margin-left: 10px;">
                <el-select v-model="time_slot_unit" placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in timeOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24" class="info-item">
            <el-row>
              <el-col :span="4">
                <div class="colm-left">访视窗口期:</div>
              </el-col>
              <el-col :span="4">
                <el-input v-model="window_period" size="mini" oninput="value=value.replace(/[^\d]/g,'')"/>
              </el-col>
              <el-col :span="4" style="margin-left: 10px;">
                <el-select v-model="window_period_unit" placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in timeOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
              <el-col :span="4">
                <div style="border: 1px solid #F0F5FF;"/>
              </el-col>
              <el-col :span="7">
                <div
                  style="border: 1px solid #DCDFE6;height: 28px;line-height: 28px;border-radius:4px;font-size: inherit;background-color: #fff;text-align: center">
                  {{ time_slot }}{{ time_slot_unit }}±{{ window_period }}{{ window_period_unit }}
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24" class="info-item">
            <el-row>
              <el-col :span="4">
                <div class="colm-left">访视阶段：</div>
              </el-col>
              <el-col :span="20">
                <el-select v-model="stage" placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in stageList"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24" class="info-item">
            <el-row>
              <el-col :span="4">
                <div class="colm-left">访视描述：</div>
              </el-col>
              <el-col :span="20">
                <el-input
                  v-model="desc"
                  size="mini"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  placeholder="请输入内容"
                />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-preventReClick size="mini" type="primary" @click="addOrEdit">保 存</el-button>
        <el-button size="mini" @click="cancel">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getVisit, addVisit, delVisit, editVisit, detailVisit} from '@/api/visit'
import {getProjectId, getProStatus, setProStatus} from '@/utils/auth'
import {detailPro} from '@/api/homePage'

export default {
  name: 'Visit',
  data() {
    return {
      proStatus: '', // 项目状态
      cellStyle: {
        textAlign: 'center'
      },
      visitData: [],
      key: '',
      proId: '',
      pageSize: 10,
      currentPage: 1,
      total: null,
      visitDialogVisible: false,
      timeOption: [
        {
          value: '天',
          label: '天'
        },
        {
          value: '周',
          label: '周'
        }
      ],
      stageList: [
        {
          value: '筛选期',
          text: '筛选期'
        },
        {
          value: '就诊期',
          text: '就诊期'
        },
        {
          value: '治疗期',
          text: '治疗期'
        },
        {
          value: '随访期',
          text: '随访期'
        },
        {
          value: '总结期',
          text: '总结期'
        }
      ],
      name: '',
      code: '',
      stage: '',
      time_slot: null,
      time_slot_unit: '天',
      window_period: null,
      window_period_unit: '天',
      desc: '',
      visitId: '',
      loading: false,
      filter: null // 筛选项
    }
  },
  created() {
    this.proId = getProjectId()
    this.getVisit()
    this.proStatus = getProStatus()
  },
    watch: {
    key(value) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.getVisit, 500);
    },
  },
  methods: {
    filterChange(filter) {
      console.info(filter)
      this.filter = filter.stage
      this.getVisit()
    },
    getVisit() {
      this.loading = true
      const params = {
        project_id: this.proId,
        key: this.key,
        page: this.currentPage - 1,
        page_size: this.pageSize,
        stage_list: this.filter
      }
      const res = this.$qs.stringify(params, {arrayFormat: 'repeat'})
      // params = { ...params, ...this.filter }
      console.info(res)
      getVisit(res).then(res => {
        if (res && res.code === 0) {
          this.loading = false
          if (res.data && res.data.length > 0) {
            this.visitData = res.data
            this.total = res.total
          } else {
            this.visitData = []
          }
          this.total = res.total
        } else {
          this.$message(res.msg)
        }
      }).catch(res => {
        console.log(res.msg)
      })
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getVisit()
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val
      this.getVisit()
    },
    // 修改表头颜色
    tableHeaderColor({row, column, rowIndex, columnIndex}) { // 改表头颜色
      if (rowIndex === 0) {
        return 'background-color: #D6E4FF;color: #595959;text-align:center;'
      }
    },
    addVisitShow() {
      this.visitId='';
      this.visitDialogVisible = true
    },
    validata() {
      if (!this.name) {
        this.$message({
          message: '请填写访视全称',
          type: 'warning'
        })
        return false
      }
      if (!this.code) {
        this.$message({
          message: '请填写访视编号',
          type: 'warning'
        })
        return false
      }
      if (!this.time_slot) {
        this.$message({
          message: '请填写访视时间',
          type: 'warning'
        })
        return false
      }
      if (!this.time_slot_unit) {
        this.$message({
          message: '请选择访视时间单位',
          type: 'warning'
        })
        return false
      }
      if (this.window_period==="") {
        this.$message({
          message: '请填写访视窗口期',
          type: 'warning'
        })
        return false
      }
      if (!this.window_period_unit) {
        this.$message({
          message: '请选择访视窗口期单位',
          type: 'warning'
        })
        return false
      }
      if (!this.stage) {
        this.$message({
          message: '请选择访视阶段',
          type: 'warning'
        })
        return false
      }
      return true
    },
    addOrEdit() {
      if (this.validata()) {
        const params = {
          project_id: this.proId,
          name: this.name,
          code: this.code,
          stage: this.stage,
          time_slot: this.time_slot,
          time_slot_unit: this.time_slot_unit,
          window_period: this.window_period,
          window_period_unit: this.window_period_unit,
          desc: this.desc
        }
        if (!this.visitId) {
          this.addVisit(params)
        } else {
          params.id = this.visitId
          this.editVisit(params)
        }
      }
    },
    cancel() {
      console.log(111)
      this.name = ''
      this.code = ''
      this.stage = ''
      this.time_slot = null
      this.time_slot_unit = '天'
      this.window_period = null
      this.window_period_unit = '天'
      this.desc = ''
      this.visitDialogVisible = false
      this.getVisit()
    },
    addVisit(params) {
      addVisit(params).then(res => {
        if (res && res.code === 0) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.visitDialogVisible = false
          this.cancel()
        } else {
          this.$message(res.msg)
        }
      }).catch(res => {
        console.log(res.msg)
      })
    },
    // 回显示
    showVisit(row) {
      this.visitId = row.id
      this.visitDialogVisible = true
      const params = {
        project_id: this.proId,
        id: row.id
      }
      detailVisit(params).then(res => {
        if (res && res.code === 0) {
          this.name = res.data.name
          this.code = res.data.code
          this.stage = res.data.stage
          this.time_slot = res.data.time_slot
          this.time_slot_unit = res.data.time_slot_unit
          this.window_period = res.data.window_period
          this.window_period_unit = res.data.window_period_unit
          this.desc = res.data.desc
          console.log(res)
        } else {
          this.$message.error(res.msg)
        }
      }).catch(res => {
        console.log(res.msg)
      })
    },
    editVisit(params) {
      editVisit(params).then(res => {
        if (res && res.code === 0) {
          this.visitId = ''
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.cancel()
        } else {
          this.$message(res.msg)
        }
      }).catch(res => {
        console.log(res.msg)
      })
    },
    del(row) {
      this.$confirm(`是否确认删除访视 <span style="color: #698CFC;font-size: 14px;font-weight: bold;">${row.name} </span>?`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.id,
          project_id: this.proId
        }
        delVisit(params).then(res => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.getVisit()
          } else {
            this.$message(res.msg)
          }
        }).catch(res => {
          console.log(res.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
.btn {
  text-align: right;
}

.container-table {
  margin-top: 20px;
}

.title {
  padding: 15px 0;
  background-color: #D6E4FF;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}

.proInfo {
  background-color: #F0F5FF;
  padding: 20px 30px;
}

.row {
  margin: 20px 0;
  font-size: 14px;
  color: #595959;
}

.colm-left {
  line-height: 26px;
}

.pages {
  margin-top: 30px;
  text-align: right;
}

.edit {
  font-size: 12px;
  margin-right: 10px;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}

.container-table {
  border: 1px solid #E5EEFF;
}

.el-tooltip__popper.is-light {
  border: none;
  background: #FFFFFF;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08), -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}

.popper__arrow {
  border: none !important;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}

.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}

.diaBg {
  background-color: #F0F5FF;
  padding: 20px;
}
</style>
